import { logger } from '@/utils/logger';

export const GEOLOCATION_TIMEOUT_MS = 8_000;

export interface BrowserCoordinates {
  lat: number;
  lng: number;
  capturedAt: string;
}

/**
 * Read a fresh browser position for customer proximity gates.
 * Permission/provider failures intentionally collapse to null so the server
 * can return the same GPS_UNAVAILABLE contract used by waitlist arrival.
 */
export function requestCurrentCoordinates(): Promise<BrowserCoordinates | null> {
  if (typeof navigator === 'undefined' || !navigator.geolocation) {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => resolve({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        capturedAt: new Date(position.timestamp || Date.now()).toISOString(),
      }),
      (error) => {
        // Browser error attributes may be inherited and disappear in JSON.
        // Keep finite diagnostics without provider messages or location data.
        const code = error.code;
        logger.warn('[geolocation] 위치 취득 실패',
          { diagnostic_marker: 'menu.waitlist.geolocation.v1', operation: 'position-read', ...(code === 1 || code === 2 || code === 3 ? { code } : {}) },
        );
        resolve(null);
      },
      {
        enableHighAccuracy: true,
        timeout: GEOLOCATION_TIMEOUT_MS,
        maximumAge: 0,
      },
    );
  });
}
